
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { sourceRunPage } from '../../pages/workspace-sources/shared/analytics'
import { Menu, MenuLink } from '../NavigationMenu'
import { FlexGrid, FlexItem } from '../flexgrid'
import { joinErrors, joinWarnings } from 'lib/runs/join'
import { getStatusLabelReact as getStatusLabel } from 'lib/utils'
import RunEventList from './run-event-list'
import Table from '../Table2'
import Block from '../Block'
import ShowHide from '../ShowHide'
import RunAdmin from './run-admin'
import numeral from 'numeral'
import './index.css'

/**
 * Columns.
 */

const columns = [
  {
    label: 'Status',
    name: 'status',
    type: 'string',
    width: '110px'
  },
  {
    label: 'Collection',
    name: 'name',
    type: 'string',
    width: 'auto'
  },
  {
    label: 'Synced',
    name: 'synced',
    type: 'number',
    width: '125px',
    align: 'right'
  }
]

class Run extends Component {
  constructor () {
    super()
    this.state = {}
  }

  render () {
    const { sourceId, warehouseId, user, name, type, run } = this.props
    const activeTab = this.state.activeTab || 'collections'
    const rows = run.collections.map(function (collection) {
      return {
        name: { value: collection.name },
        synced: { value: collection.synced, content: numeral(collection.synced).format('0,0') },
        status: { value: collection.status, content: getStatusLabel(collection.status) }
      }
    })

    const errors = joinErrors(run)
    const warnings = joinWarnings(run)

    const errorCount = errors.length
    const warningCount = warnings.length

    let adminLink
    let adminTab

    if (user.isAdmin) {
      adminLink = <MenuLink active={activeTab === 'admin'} onSelect={() => this.setState({ activeTab: 'admin' })}>Admin</MenuLink>
      adminTab = (
        <Block hidden={activeTab !== 'admin'}>
          <RunAdmin kind={type} sourceId={sourceId} warehouseId={warehouseId} run={run} />
        </Block>
      )
    }

    let RunMenu = (
      <Menu size='large'>
        <MenuLink active={activeTab === 'collections'} onSelect={() => this.setState({ activeTab: 'collections' })}>Results</MenuLink>
        {adminLink}

        <ShowHide show={errorCount > 0}>
          <MenuLink active={activeTab === 'errors'} onSelect={() => this.setState({ activeTab: 'errors' })} count={errorCount} countType='error'>Errors</MenuLink>
        </ShowHide>

        <ShowHide show={warningCount > 0}>
          <MenuLink active={activeTab === 'warnings'} onSelect={() => this.setState({ activeTab: 'warnings' })} count={warningCount} countType='warning'>Warnings</MenuLink>
        </ShowHide>
      </Menu>
    )

    return (
      <FlexGrid>
        <FlexItem spaceRight={30} width={180}>
          {RunMenu}
        </FlexItem>
        <FlexItem flex={1} width={300}>
          <Block hidden={activeTab !== 'collections'}>
            <Table
              emptyText='No collections were synced'
              keyField='name'
              columns={columns}
              rows={rows} />
          </Block>
          {adminTab}
          <Block hidden={activeTab !== 'errors'}>
            <RunEventList
              events={errors}
              label='errors'
              type={type}
              name={name} />
          </Block>
          <Block hidden={activeTab !== 'warnings'}>
            <RunEventList
              events={warnings}
              label='warnings'
              type={type}
              name={name} />
          </Block>
        </FlexItem>
      </FlexGrid>
    )
  }

  componentDidMount () {
    const { type, source, sourceSummary, workspace } = this.props
    // if it's not a source run, then don't track anything for now.
    if (!source) return

    let lastRun = this.props.lastRun || {}
    if (!Object.keys(lastRun).length && sourceSummary) {
      // if lastRun is still pending, then choose the most recently-completed run instead (index 1)
      lastRun = sourceSummary.lastRun.status === 'pending'
        ? sourceSummary.runs[1]
        : sourceSummary.lastRun
    }
    sourceRunPage({ type, source, lastRun, workspace })
  }
}

Run.propTypes = {
  sourceId: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  name: PropTypes.string,
  type: PropTypes.string.isRequired,
  run: PropTypes.object,
  source: PropTypes.object,
  sourceSummary: PropTypes.object
}

Run.displayName = 'Run'

export default Run



// WEBPACK FOOTER //
// ./ui/Run/index.js